import { render, staticRenderFns } from "./loginRegister.vue?vue&type=template&id=23f5d202&scoped=true"
import script from "./loginRegister.vue?vue&type=script&lang=js"
export * from "./loginRegister.vue?vue&type=script&lang=js"
import style0 from "./loginRegister.vue?vue&type=style&index=0&id=23f5d202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f5d202",
  null
  
)

export default component.exports